export function groupChildrenByColumn<T extends { custom: unknown }>(children: T[], columns: number): T[][] {
	const safeColumns = Math.max(1, Math.min(4, Number.isFinite(columns) ? columns : 1))
	const groups: T[][] = Array.from({ length: safeColumns }, () => [])
	for (const child of children) {
		const customObj =
			typeof child.custom === 'object' && child.custom !== null ? (child.custom as Record<string, unknown>) : {}
		const rawCol = Number(customObj.column ?? 0)
		const col = Number.isFinite(rawCol) ? rawCol : 0
		const safeCol = Math.min(Math.max(col, 0), safeColumns - 1)
		groups[safeCol].push(child)
	}
	return groups
}

export function getColumns(custom: Record<string, unknown>): number {
	const rawColumns = Number(custom.columns ?? 1)
	const columns = Number.isFinite(rawColumns) ? rawColumns : 1
	return Math.min(Math.max(columns, 1), 4)
}

/**
 * Normalize a repeatable section's max value.
 * A stored max of 0 or negative is treated as unset (unlimited),
 * preventing broken "N of 0" displays and a blocked add button.
 */
export function normalizeMax(max: number | null | undefined): number | undefined {
	return max != null && max > 0 ? max : undefined
}
